export const ONEDRIVE_CONSUMER = {
  baseUrl: 'https://onedrive.live.com',
  pickerPath: 'picker',
  tenantId: '9188040d-6c67-4c5b-b112-36a304b66dad',
  authority: 'https://login.microsoftonline.com/consumers',
  accountDomains: ['hotmail.com', 'live.com', 'msn.com', 'outlook.com'],
  resourceHosts: [
    'onedrive.live.com',
    'my.microsoftpersonalcontent.com',
    'api.onedrive.com'
  ]
};

export const MICROSOFT_GRAPH = {
  baseUrl: 'https://graph.microsoft.com/v1.0',
  defaultScope: 'https://graph.microsoft.com/.default'
};

export const MSAL_SCOPES = {
  oneDriveReadWrite: 'OneDrive.ReadWrite',
  userRead: 'User.Read'
};
